import { ConstantsParser } from '../ConstantsParser'

export class ClassesBuilder {

  constructor(classes) {
    this.classes = classes
  }

  filterClasses() {
    let responsiveClasses = (new ConstantsParser(this.parseProperties())).parseResponsiveClasses()

    if (!responsiveClasses.length) return [];

    return responsiveClasses
  }

  parseProperties() {
    let phoneProperties = this.getPropertiesByDevice('phone')
    let tabletProperties = this.getPropertiesByDevice('tablet')
    let desktopProperties = this.getPropertiesByDevice('desktop')

    let filteredTabletProperties = tabletProperties.filter( item => {
      return !phoneProperties.some( (p) => item.property === p.property && item.value === p.value)
        && !desktopProperties.some( (d) => item.property === d.property && item.value === d.value)
    })

    let filteredDesktopProperties = desktopProperties.filter( item => {
      return !tabletProperties.some( (t) => item.property === t.property && item.value === t.value)
        && !phoneProperties.some( (p) => item.property === p.property && item.value === p.value)
    })

    return new Object({
      desktop: filteredDesktopProperties,
      phone: phoneProperties,
      tablet: filteredTabletProperties
    })
  }

  getPropertiesByDevice(device) {
    return this.classes[device]
  }

  parseClasses() {
    return this.filterClasses()
  }
}
